import { generatePath } from 'react-router-dom';

export const ROUTES = {
  base: '/',
  oauthAuthorize: 'oauth/authorize',
  signIn: 'sign-in',
  signUp: 'sign-up',
  reset: 'reset',
  forgot: 'forgot',
  authConfirmation: 'confirmation',
  admin: {
    base: 'admin',
    users: 'users',
    companies: 'companies',
    connections: 'connections',
    accounts: 'accounts',
    managedCompanies: 'managed-companies',
    reportSettings: 'report-settings',
    exportRenderers: 'export-renderers',
    mapFiles: 'map-files',
    geo: 'geo',
    geoJobs: 'geo/jobs',
    geoJobsJobId: 'geo/jobs/:jobId',
    geoJobsJobIdGeofences: 'geo/jobs/:jobId/geofences',
    geoJobsJobIdDistances: 'geo/jobs/:jobId/distances',
    geoOrders: 'geo/orders',
    geoOrdersOrderId: 'geo/orders/:orderId',
    geoOrdersOrderIdDistances: 'geo/orders/:orderId/distances',
    geoLoads: 'geo/loads',
    geoLoadsLoadId: 'geo/loads/:loadId',
    geoLoadsLoadIdDistances: 'geo/loads/:loadId/distances',
    geoDriverDays: 'geo/driver_days',
    geoDriverDaysDriverDayId: 'geo/driver_days/:driverDayId',
    geoDriverDaysDriverDayIdDistances: 'geo/driver_days/:driverDayId/distances',
    utilities: 'utilities',
  },
  approvals: {
    base: 'approvals',
    driverDay: 'driver-day',
    driverPay: 'driver-pay',
    ticketsReview: 'tickets-review',
    approveCharges: 'approve-charges',
    approveJobs: 'approve-jobs',
    approveJobsByJobId: 'payables/job',
    timesheets: 'timesheets',
  },
  settings: {
    base: 'settings',
    userProfile: 'user-profile',
    generalSettings: 'general-settings',
    companyOnboarding: 'company-onboarding',
    companyOnboardingStep: 'company-onboarding/:stepKey',
    accounts: 'accounts',
    customers: 'customers',
    vendors: 'vendors',
    vendorManagement: 'vendors/:managedCompanyId/manage',
    userManagement: 'user-management',
    drivers: 'drivers',
    companies: 'companies',
    equipmentTypeManagement: 'equipment-type',
    equipmentManagement: 'equipment',
    materialTypeManagement: 'material-type',
    materialsManagement: 'materials',
    ratesManagement: 'rates',
    addOnCharges: 'rates/add-on-charges',
    materialRatesManagement: 'rates/material-rates',
    commissionDefaults: 'rates/pay-commission-defaults',
    automaticSettlementAddOnManagement: 'rates/automatic-settlement-add-ons',
    fuelSurchargeManagement: 'rates/fuel-surcharge',
    fuelPriceIndexManagement: 'rates/fuel-price-index',
    fuelSurchargeScheduleManagement: 'rates/fuel-surcharge-schedule',
    sitesManagement: 'sites',
    departmentsManagement: 'departments',
    paymentTermsManagement: 'payment-terms',
    labelsManagement: 'labels',
    overtimeRulesManagement: 'overtime-rules',
    prevailingWageBenefitsManagement: 'prevailing-wage-benefits',
    serviceClassesManagement: 'service-classes',
    taxRateScheduleManagement: 'tax-rate-schedules',
    configuration: 'configuration',
    routeOptimization: 'route-optimization',
    billing: 'billing',
    integrations: {
      base: 'integrations',
      catena: {
        base: 'catena',
        vehicles: 'vehicles',
      },
      commandAlkon: 'command-alkon',
      fastWeigh: 'fast-weigh',
      haulWare: 'haul-ware',
      paverTracker: 'paver-tracker',
      rutter: {
        base: 'rutter',
        quickBooks: 'quick-books',
      },
      vetaCenter: 'veta-center',
    },
    agents: 'agents',
    apiClients: 'api-clients',
    complianceDocumentTypes: 'compliance-document-types',
    deletedRecords: 'deleted-records',
  },
  dispatch: {
    base: 'dispatch',
    orders: 'orders',
    jobs: 'jobs',
    v3: 'dispatch_v3',
  },
  dashboard: 'dashboard',
  messages: 'messages',
  reconciliation: 'reconciliation',
  live: 'live',
  projects: 'projects',
  payments: 'payments',
  reports: 'reports',
  assigned: 'assigned',
};

export const settingsPagePath = (settingsLink: string) =>
  `/${ROUTES.settings.base}/${settingsLink}`;

export const companyOnboardingChecklistPath = settingsPagePath(
  ROUTES.settings.companyOnboarding,
);

export const companyOnboardingStepPath = (stepKey: string) =>
  settingsPagePath(generatePath(ROUTES.settings.companyOnboardingStep, { stepKey }));

export const rutterManageSettingsLink = `${ROUTES.settings.integrations.base}/${ROUTES.settings.integrations.rutter.base}`;

export const catenaManageSettingsLink = `${ROUTES.settings.integrations.base}/${ROUTES.settings.integrations.catena.base}`;
